import { useState, useRef } from "react";
import { Upload, X, Loader2 } from "lucide-react";
import { api, fileUrl } from "@/lib/api";
import { toast } from "sonner";

export function SingleUploader({ value, onChange, testid = "uploader" }) {
  const [loading, setLoading] = useState(false);
  const ref = useRef();
  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
    } catch { toast.error("Échec de l'upload"); } finally { setLoading(false); }
  };
  return (
    <div>
      {value ? (
        <div className="relative w-full h-40 rounded-lg overflow-hidden border border-border">
          <img src={fileUrl(value)} alt="" className="w-full h-full object-cover" />
          <button type="button" onClick={() => onChange("")} className="absolute top-2 right-2 h-7 w-7 bg-ink/80 text-white rounded-full flex items-center justify-center"><X size={15} /></button>
        </div>
      ) : (
        <button type="button" onClick={() => ref.current.click()} data-testid={testid}
          className="w-full h-40 rounded-lg border-2 border-dashed border-border flex flex-col items-center justify-center text-ink/50 hover:border-primary hover:text-primary transition">
          {loading ? <Loader2 className="animate-spin" /> : <><Upload size={22} /><span className="text-sm mt-2">Choisir une image</span></>}
        </button>
      )}
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={upload} />
    </div>
  );
}

export function GalleryUploader({ value = [], onChange, testid = "gallery-uploader" }) {
  const [loading, setLoading] = useState(false);
  const ref = useRef();
  const upload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setLoading(true);
    try {
      const urls = [];
      for (const file of files) {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        urls.push(data.url);
      }
      onChange([...value, ...urls]);
    } catch { toast.error("Échec de l'upload"); } finally { setLoading(false); }
  };
  return (
    <div>
      <div className="grid grid-cols-3 gap-2">
        {value.map((v, i) => (
          <div key={i} className="relative h-20 rounded-lg overflow-hidden border border-border">
            <img src={fileUrl(v)} alt="" className="w-full h-full object-cover" />
            <button type="button" onClick={() => onChange(value.filter((_, x) => x !== i))} className="absolute top-1 right-1 h-6 w-6 bg-ink/80 text-white rounded-full flex items-center justify-center"><X size={13} /></button>
          </div>
        ))}
        <button type="button" onClick={() => ref.current.click()} data-testid={testid}
          className="h-20 rounded-lg border-2 border-dashed border-border flex items-center justify-center text-ink/50 hover:border-primary hover:text-primary">
          {loading ? <Loader2 className="animate-spin" size={18} /> : <Upload size={18} />}
        </button>
      </div>
      <input ref={ref} type="file" accept="image/*" multiple className="hidden" onChange={upload} />
    </div>
  );
}
